import { assertSome } from '@crocodille/util';
import { Map as MapboxMap } from 'mapbox-gl';

export function loadMapboxImage(map: MapboxMap, url: string) {
  return new Promise<HTMLImageElement | ImageBitmap>((resolve, reject) => {
    map.loadImage(url, (error, image) => {
      if (error) {
        reject(error);
      } else {
        resolve(assertSome(image));
      }
    });
  });
}
